<template>
  <b-container fluid style="max-width:1200px;">
    <b-row style="margin-top: 4em">
      <b-col>
        <h2 class="text-secondary">
          {{ $t("globals.all_services") }}
          <icon v-if="getAllServicesLoading" name="spinner" spin></icon>
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small hover
          primary-key="id"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :items="getAllServices"
          :fields="fields"
          @row-clicked="rowClicked"
          @filter-function="onFiltered"
        >
          <template v-slot:cell(created_at)="item">
            <div v-b-tooltip.hover :title="item.item.created_at">
              {{ item.item.created_at.substring(0, 10) }}
            </div>
          </template>
          <template v-slot:cell(warranty)="item">
            <v-icon v-if="item.item.warranty" name="regular/check-square" ></v-icon>
            <v-icon v-else name="regular/square" ></v-icon>
          </template>
          <template v-slot:cell(needs_to_be_billed)="item">
            <v-icon v-if="item.item.needs_to_be_billed" name="regular/check-square" ></v-icon>
            <v-icon v-else name="regular/square" ></v-icon>
          </template>
          <template v-slot:cell(customer)="item">
            <router-link
              v-if="item.item.customer != null"
              style="color:#17a2b8"
              :to="{name: 'customer', params:{ id: item.item.customer.id }}"
              target="_blank"
            >
              {{ item.item.customer.company_name }}
            </router-link>
          </template>
          <template v-slot:cell(order)="item">
            <router-link
              style="color:#17a2b8"
              :to="{name: 'order', params:{ id: item.item.order.id }}"
              target="_blank"
            >
              {{ item.item.order.order_no }}
            </router-link>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="my-1">
       
        <b-pagination
          :total-rows="getAllServices.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  data() {
   return {
      sortBy: this.$route.query.sortBy || "id",
      sortDesc:this.$route.query.sortDesc !== undefined ?  String(this.$route.query.sortDesc).toLowerCase() == 'true' : true,
      filter: this.$route.query.filter || null,
      currentPage: this.$route.query.currentPage || 1,
      perPage: this.$route.query.perPage || 20,

      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "agent.full_name",
          label: this.$t("globals.agent"),
          sortable: true
        },
        {
          key: "customer",
          label: this.$t("globals.customer"),
          sortable: true
        },
        {
          key: "order",
          label: this.$t("globals.order_no"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "service_type",
          label: this.$t("globals.service_type"),
          sortable: true
        },
        {
          key: "fieldtracker_task_name",
          label: this.$t("globals.fieldtracker_task_name"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        }
      ], 
     };
  },
  methods: {
    ...mapActions(["fetchAllServices"]),
    rowClicked(item) {
      this.setFiltersInURL();
      this.$router.push({ name: "service", params: { id: item.id } });
    },
    onFiltered() {
      this.currentPage = 1;
    },
    setFiltersInURL(){
      this.$router.replace({ query: { filter: this.filter, perPage: this.perPage, sortBy: this.sortBy, sortDesc:this.sortDesc, currentPage:this.currentPage } }).catch(()=>{});
    }
  },
  computed: {
    ...mapGetters([
      "getAllServices",
      "getAllServicesLoading",
      "getUserBrandPermissions"
    ])
  },
  created() {
    if (!this.getUserBrandPermissions.order_service_index) {
      this.$router.push({ name: "dashboard" });
    }
  },
  mounted() {
    if(this.getAllServices.length == 0){
      this.fetchAllServices();
    }
  },
  watch:{
    getAllServicesLoading(n,o){
      this.filter = this.$route.query.filter || null;
      this.perPage = this.$route.query.perPage || 20;
      this.sortBy = this.$route.query.sortBy || "id";
      this.sortDesc =this.$route.query.sortDesc !== undefined ?  String(this.$route.query.sortDesc).toLowerCase() == 'true' : true;
      this.currentPage = this.$route.query.currentPage || 1;
    },

    filter(n,o){
      this.currentPage = 1;
    },
    sortBy(n,o){
      this.currentPage = 1;
    },
    sortDesc(n,o){
      this.currentPage = 1;
    },
  }


};
</script>
